if (document.getElementById('soundText')) {
    $(document).ready(function(){
        $('.main-banner__sound').click(function() {
            $('.sound-line').toggleClass('sound-off');
            changeSoundText()
        })
    })
    
    changeSoundText()
    
    function changeSoundText() {
        if (document.querySelector('.sound-line.sound-off')) {
            document.getElementById('soundText').innerHTML = 'sound-off'
            soundText.classList.remove("sound-on")
        } else {
            document.getElementById('soundText').innerHTML = 'sound-on'
            soundText.classList.add("sound-on")
        } 
    }
}    


if (document.getElementById('playFull')) {
    document.getElementById('playFull').onclick = () => {
        openFullscreen()
    }
}

/* When the openFullscreen() function is executed, open the video in fullscreen.
Note that we must include prefixes for different browsers, as they don't support the requestFullscreen method yet */
function openFullscreen() {
    let elem = document.getElementById("videoFull"); 
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
        videoFull.classList.add("active")
        videoFull.play()
        videoFull.addEventListener('ended', e => {
        })
    } else {
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
            document.addEventListener('fullscreenchange', exitHandler, false);
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
            document.addEventListener('mozfullscreenchange', exitHandler, false);
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
            document.addEventListener('webkitfullscreenchange', exitHandler, false);
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem.msRequestFullscreen();
            document.addEventListener('MSFullscreenChange', exitHandler, false);
        }
    }
}

function exitHandler() {
    
    if ($(document)[0].fullscreen)
    // if (document.fullscreenElement || document.mozFullScreen || document.msFullscreenElement !== null)
    {
        videoFull.classList.add("active")
        videoFull.play()
        // console.log(2);
        
    } else {
        videoFull.pause()
        videoFull.currentTime = 0
        videoFull.classList.remove("active")
    }
}

document.addEventListener("DOMContentLoaded", e => {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) && document.querySelector("#bannerVideo") && document.querySelector("#mainBanner")) {
        document.querySelector("#bannerVideo").classList.add("hide")
        document.querySelector("#mainBanner").classList.add("active")
        // console.log('fdfd')
    }
})